import { AgentOverridesService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/inference-client';
import type { AgentOverrideMetadata, TypedAgentOverride } from '../model/tools.types';

export const getAgentOverrides = async (agentId: string): Promise<TypedAgentOverride[]> => {
  const response = await AgentOverridesService.getAllOverridesForAgent({
    client: inferenceHttp,
    path: { agentId },
  });

  const responseData = response.data as { items?: TypedAgentOverride[] } | undefined;
  return responseData?.items ?? [];
};

export const createAgentOverride = async (
  agentId: string,
  metadata: AgentOverrideMetadata,
  workspaceId?: string,
  organizationId?: string,
): Promise<void> => {
  await AgentOverridesService.create({
    client: inferenceHttp,
    path: { agentId },
    body: {
      workspaceId,
      organizationId,
      override: {
        metadata,
      },
    },
  });
};

export const updateAgentOverride = async (
  overrideId: string,
  metadata: AgentOverrideMetadata,
  workspaceId?: string,
): Promise<void> => {
  await AgentOverridesService.update({
    client: inferenceHttp,
    path: { agentId: overrideId }, // Backend bug: uses agentId param as overrideId
    body: {
      workspaceId,
      override: {
        metadata,
      },
    },
  });
};
